export const ENV = {
    itemsPerPage: 20,
    currentPage: 1,
    maxSize: 5,
    dateFormat: 'DD/MM/YYYY',
    buildVersion:  '4.8.0',
    releaseDate: "2025-06-26"
};
